// LeagueIdentityProvider — resolves a league/competition logo URL with strict provenance.
// Priority: real provider logo -> cached real logo -> null (UI shows country flag + text).
// No fabricated league logos. Country flags remain handled by countryFlags.ts.

export interface LeagueIdentity {
  logoUrl: string | null;
}

const cache = new Map<string, string | null>();

export function registerLeagueLogo(leagueKey: string, logoUrl: string | null) {
  cache.set(leagueKey.toLowerCase(), logoUrl || null);
}

export function leagueIdentity(league: string | null | undefined): LeagueIdentity {
  const clean = (league || "").trim();
  if (!clean) return { logoUrl: null };
  return { logoUrl: cache.get(clean.toLowerCase()) ?? null };
}
